import styled, { css } from 'styled-components/macro';
import chevron from 'assets/icons/chevron.svg';
import check from 'assets/icons/check.svg';

export const ChevronIcon = styled.img.attrs({
  src: chevron,
})<{ isOpen: boolean }>`
  height: 16px;
  width: 16px;
  rotate: ${(props) => (props.isOpen ? '0' : '-90deg')};
  cursor: pointer;
`;

export const EmptyIcon = styled.div`
  padding-left: 16px;
`;

export const Text = styled.div`
  width: 100%;
  padding: 10px 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const Counter = styled.div`
  padding: 10px 0;
  color: #495466;
  font-family: Roboto Mono, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  width: fit-content;
  box-sizing: border-box;
  white-space: nowrap;
`;

export const SelectButton = styled.div`
  display: none;
  cursor: pointer;
  color: #2d67d8;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  width: fit-content;
  white-space: nowrap;
  position: absolute;
  padding: 12px;
  right: 0;
  background-color: inherit;

  :hover {
    color: #1d4ed6;
  }
`;

export const Wrapper = styled.div<{
  isSelected: boolean;
  level: number;
  $isDisabled: boolean;
}>`
  display: flex;
  background-color: ${(props) => (props.isSelected ? '#f2f5f8' : '#ffffff')};
  cursor: default;
  padding: 0 12px 0 ${(props) => `${props.level * 12}px`};
  gap: 8px;
  align-items: center;
  position: relative;

  ${({ theme, $isDisabled }) => css`
    ${Text} {
      color: ${theme.colors.gray[$isDisabled ? '400' : '800']};
      cursor: ${$isDisabled ? 'not-allowed' : 'pointer'};
    }

    :hover {
      background-color: ${$isDisabled ? '#ffffff' : '#f2f5f8'};

      & > ${SelectButton} {
        display: inline;
      }
    }
  `}
`;

export const CheckIcon = styled.img.attrs({
  src: check,
})`
  height: 16px;
  width: 16px;
  cursor: pointer;
`;
